import { render } from "./workOrderHistoryTable.vue?vue&type=template&id=ddf3a6c8"
import script from "./workOrderHistoryTable.vue?vue&type=script&lang=js"
export * from "./workOrderHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__